module.exports = __webpack_public_path__ + "img/NukedTV-Web_41.bda8cecf.png";